import { DataSource, ExtractionStatus } from "@inrev/common";
import { type FC } from "react";
import { UploadedDocumentRow } from "./types";

const dataSourceLabels: Record<DataSource, string> = {
	[DataSource.manual]: "Manual",
	[DataSource.extraction]: "Extraction",
};

type FinancialExtractionDeleteDialogContentProps = {
	row: UploadedDocumentRow;
};

export const FinancialExtractionDeleteDialogContent: FC<
	FinancialExtractionDeleteDialogContentProps
> = ({ row }) => {
	const ext = row.financialExtraction;
	const fileLabel = [row.file.name, row.file.extension].join(".");

	if (!ext) {
		return (
			<div className="w-[375px] text-center break-words">
				Are you sure you want to delete
				<br />
				{fileLabel}?
			</div>
		);
	}

	return (
		<div className="w-full max-w-lg space-y-3 text-left">
			<p className="text-[15px] text-primary">
				Delete <span className="font-medium">{fileLabel}</span>? This will also permanently remove
				the associated financial extraction and cannot be undone.
			</p>
			<dl className="space-y-1 text-sm text-secondary">
				<div className="flex gap-2">
					<dt className="font-medium text-primary">Source:</dt>
					<dd>{dataSourceLabels[ext.dataSource]}</dd>
				</div>
				<div className="flex gap-2">
					<dt className="font-medium text-primary">Status:</dt>
					<dd>{ExtractionStatus.displayName(ext.status)}</dd>
				</div>
			</dl>
		</div>
	);
};
